import { createContext } from "react";

const userContext = createContext("sre");

export default userContext;